var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 230,
    viewBox: "0 0 258 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.382 229.402C191.729 229.402 243.083 178.049 243.083 114.701C243.083 51.3534 191.729 0 128.382 0C65.0341 0 13.6807 51.3534 13.6807 114.701C13.6807 178.049 65.0341 229.402 128.382 229.402Z",
    fill: "url(#paint0_linear_4129_5463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.263 26.6904H63.198C55.2779 26.6904 48.8574 33.1109 48.8574 41.031H204.603C204.603 33.1109 198.183 26.6904 190.263 26.6904Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8574 40.6387H204.603V159.257C204.603 164.531 202.508 169.589 198.779 173.318C195.05 177.047 189.992 179.142 184.718 179.142H68.7425C63.4687 179.142 58.4108 177.047 54.6816 173.318C50.9525 169.589 48.8574 164.531 48.8574 159.257V40.6387Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 55.6221H75.6791C73.5517 55.6221 71.8271 57.3448 71.8271 59.4699C71.8271 61.5949 73.5517 63.3176 75.6791 63.3176H177.831C179.958 63.3176 181.683 61.5949 181.683 59.4699C181.683 57.3448 179.958 55.6221 177.831 55.6221Z",
    fill: "#E5E7EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 88.3174H75.6791C73.5517 88.3174 71.8271 90.0401 71.8271 92.1652C71.8271 94.2903 73.5517 96.013 75.6791 96.013H177.831C179.958 96.013 181.683 94.2903 181.683 92.1652C181.683 90.0401 179.958 88.3174 177.831 88.3174Z",
    fill: "#E5E7EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 121.013H75.6791C73.5517 121.013 71.8271 122.735 71.8271 124.86C71.8271 126.986 73.5517 128.708 75.6791 128.708H177.831C179.958 128.708 181.683 126.986 181.683 124.86C181.683 122.735 179.958 121.013 177.831 121.013Z",
    fill: "#E5E7EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 153.708H75.6791C73.5517 153.708 71.8271 155.431 71.8271 157.556C71.8271 159.681 73.5517 161.404 75.6791 161.404H177.831C179.958 161.404 181.683 159.681 181.683 157.556C181.683 155.431 179.958 153.708 177.831 153.708Z",
    fill: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4129_5463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9873 114H20.593C16.2231 114 12.6807 117.542 12.6807 121.912V199.66C12.6807 204.03 16.2231 207.573 20.593 207.573H74.9873C79.3572 207.573 82.8997 204.03 82.8997 199.66V121.912C82.8997 117.542 79.3572 114 74.9873 114Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.917 152.895H26.6622C25.2394 152.895 24.0859 154.048 24.0859 155.471V155.479C24.0859 156.902 25.2394 158.055 26.6622 158.055H68.917C70.3399 158.055 71.4934 156.902 71.4934 155.479V155.471C71.4934 154.048 70.3399 152.895 68.917 152.895Z",
    fill: "#D1D5DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9419 189.21H27.0503C25.6396 189.21 24.4961 190.327 24.4961 191.706V191.714C24.4961 193.092 25.6396 194.21 27.0503 194.21H68.9419C70.3526 194.21 71.4961 193.092 71.4961 191.714V191.706C71.4961 190.327 70.3526 189.21 68.9419 189.21Z",
    fill: "#D1D5DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9419 170.21H27.0503C25.6396 170.21 24.4961 171.327 24.4961 172.706V172.714C24.4961 174.092 25.6396 175.21 27.0503 175.21H68.9419C70.3526 175.21 71.4961 174.092 71.4961 172.714V172.706C71.4961 171.327 70.3526 170.21 68.9419 170.21Z",
    fill: "#D1D5DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.113 126.006H29.765C27.0298 126.006 24.8125 128.223 24.8125 130.958V134.385C24.8125 137.12 27.0298 139.338 29.765 139.338H42.113C44.8482 139.338 47.0655 137.12 47.0655 134.385V130.958C47.0655 128.223 44.8482 126.006 42.113 126.006Z",
    fill: "#D1D5DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M205.362 156.573L190.602 172.846L232.206 210.584L246.966 194.311L205.362 156.573Z",
    fill: "#F59E0B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.96 129.64C220.96 163.682 193.363 191.279 159.32 191.279C125.278 191.279 97.6807 163.682 97.6807 129.64C97.6807 95.597 125.278 68 159.32 68C193.363 68 220.96 95.597 220.96 129.64ZM211.505 129.64C211.505 158.461 188.141 181.825 159.32 181.825C130.499 181.825 107.135 158.461 107.135 129.64C107.135 100.819 130.499 77.4548 159.32 77.4548C188.141 77.4548 211.505 100.819 211.505 129.64Z",
    fill: "#F59E0B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4129_5463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.321 181.825C188.141 181.825 211.505 158.461 211.505 129.64C211.505 100.819 188.141 77.4551 159.321 77.4551C130.5 77.4551 107.136 100.819 107.136 129.64C107.136 158.461 130.5 181.825 159.321 181.825Z",
    fill: "#FFFBEB"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.86 129.639L186.784 114.682C188.183 113.202 188.949 111.236 188.92 109.2C188.891 107.164 188.069 105.22 186.63 103.781C185.19 102.341 183.246 101.52 181.211 101.491C179.175 101.462 177.208 102.228 175.729 103.626L160.771 118.584L145.847 103.626C145.129 102.866 144.265 102.258 143.308 101.837C142.351 101.417 141.319 101.192 140.273 101.178C139.228 101.163 138.19 101.358 137.221 101.751C136.252 102.144 135.372 102.728 134.632 103.467C133.893 104.207 133.309 105.087 132.916 106.056C132.523 107.025 132.328 108.063 132.343 109.108C132.357 110.154 132.582 111.186 133.002 112.143C133.423 113.1 134.031 113.964 134.791 114.682L149.741 129.639L134.791 144.597C134.031 145.315 133.423 146.178 133.002 147.136C132.582 148.093 132.357 149.125 132.343 150.171C132.328 151.216 132.523 152.254 132.916 153.223C133.309 154.192 133.893 155.072 134.632 155.812C135.372 156.551 136.252 157.135 137.221 157.528C138.19 157.921 139.228 158.116 140.273 158.101C141.319 158.087 142.351 157.862 143.308 157.442C144.265 157.021 145.129 156.413 145.847 155.653L160.804 140.695L175.762 155.653C177.256 156.968 179.195 157.665 181.185 157.6C183.174 157.536 185.064 156.715 186.47 155.306C187.875 153.896 188.69 152.003 188.749 150.014C188.807 148.024 188.105 146.087 186.784 144.597L171.86 129.639Z",
    fill: "#F43F5E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232.203 210.585L246.963 194.312L249.187 196.329C251.344 198.286 252.635 201.019 252.777 203.928C252.919 206.836 251.899 209.682 249.942 211.839C247.986 213.997 245.252 215.288 242.344 215.43C239.435 215.571 236.589 214.552 234.432 212.595L232.209 210.579L232.203 210.585Z",
    fill: "#F59E0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4129_5463",
    x: 0.680664,
    y: 106,
    width: 100.219,
    height: 123.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4129_5463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4129_5463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4129_5463",
    x: 90.4606,
    y: 60.7799,
    width: 137.72,
    height: 137.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4129_5463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4129_5463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4129_5463",
    x1: 127.497,
    y1: -37.3495,
    x2: 129.847,
    y2: 365.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPublic);
export default __webpack_public_path__ + "static/media/not_public.a5d410b5ee62392d79d6ad9aa9a3fd2a.svg";
export { ForwardRef as ReactComponent };